/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-07 15:05:46
 * @LastEditors: linxi
 * @LastEditTime: 2021-07-08 10:41:31
 */
import { API_PREFIX } from "./constant";
import { Request } from "./request";
import { storehouseBody } from "./storehouse";

export interface storePageParams {
  current?: number;
  size?: number;
  name?: string;
  storehouseId?: number;
  billingCategory?: number;
  state?: number;
  showFlag?: number;
  deadlineEnd?: string;
  deadlineStart?: string;
  mergeFlag?: number;
  registrationTimeHead?: string;
  registrationTimeTail?: string;
  length?: number;
}

export interface storePageBody {
  deadline?: string;
  shelfNo?: number;
  plateNo?: number;
  id?: number;
}

export interface logoutOrTotalBody {
  count?: number;
  flag?: number;
  tenantInventoryLedgerId?: number;
}

export interface simpleParams {
  ids: string;
  state: number;
}

export interface MaintanceParams {
  tenantInventoryLedgerId?: number;
  current?: number;
  maintainResult?: number;
  size?: number;
}

export function storesearchPage(params: storePageParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/inventoryledger/list`,
    method: "GET",
    params,
  };
}

export function storesearchUpdata(body: storehouseBody): Request {
  return {
    url: `${API_PREFIX}/blade-store/inventoryledger/update`,
    method: "POST",
    body,
  };
}

export function storesearchDetail(id: number): Request {
  return {
    url: `${API_PREFIX}/blade-store/inventoryledger/detail`,
    method: "GET",
    params: {
      id,
    },
  };
}

export function logoutlist(params: simpleParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/inventoryledger/logoutlist`,
    method: "POST",
    params,
  };
}

export function splitOrTotal(body: logoutOrTotalBody): Request {
  return {
    url: `${API_PREFIX}/blade-store/inventoryledger/splitputtotal`,
    method: "POST",
    body,
  };
}

export function Maintanceindetail(params: MaintanceParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/maintainitem/maintainrecord`,
    method: "GET",
    params,
  };
}
